import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

export default function ReleaseNotesPage() {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch("/release-notes.md")
      .then((res) => res.text())
      .then(setMarkdown)
      .catch(() => setMarkdown("⚠️ Failed to load release notes."));
  }, []);

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Release Notes</h1>
      <div className="prose prose-blue dark:prose-invert">
        <ReactMarkdown>{markdown}</ReactMarkdown>
      </div>
    </div>
  );
} 